(() => {
  'use strict';
  const instances = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const rootsWithin = (scope) => [
    ...(scope.matches?.('[data-cp-home-fragment]') ? [scope] : []),
    ...scope.querySelectorAll('[data-cp-home-fragment]')
  ];
  function initialize(root) {
    if (instances.has(root)) return;
    const elements = [...root.querySelectorAll('[data-cp-v10-reveal]')];
    let observer;
    if (!('IntersectionObserver' in window) || reducedMotion.matches) {
      elements.forEach((element) => element.classList.add('is-visible'));
    } else {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
      elements.forEach((element) => observer.observe(element));
    }
    if (reducedMotion.matches) {
      root.querySelectorAll('.cp-v10__hero-video').forEach((video) => video.pause());
    }
    instances.set(root, observer || null);
  }
  function initializeWithin(scope) { rootsWithin(scope).forEach(initialize); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    rootsWithin(event.target).forEach((root) => {
      instances.get(root)?.disconnect();
      instances.delete(root);
    });
  });
  reducedMotion.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('.cp-v10__hero-video').forEach((video) => video.pause());
    document.querySelectorAll('[data-cp-v10-reveal]').forEach((element) => element.classList.add('is-visible'));
  });
})();
